module.exports = __webpack_public_path__ + "static/media/hn.pictogram.a50dae58.svg";